import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './device_config_edit.routes';
import SaConfigService from '../../../../components/api/sa_config/sa_config.service';
import CompanyService from '../../../../components/api/company/company.service';
import DistStockService from '../../../../components/api/dist_stock/dist_stock.service';
import ReadonlyIf from '../../../../components/directive/readonly_if/readonly_if.directive';
import ZipSearchLogic from '../../../../components/logic/zip-search/zip-search.logic';

export class OemDeviceConfigEditController {
  /*@ngInject*/
  constructor($stateParams, SaConfigService, CompanyService, $state, $scope, $timeout, $mdDialog, DistStockService, ZipSearchLogic) {
    this.id = $stateParams.id;
    this.companyId = $stateParams.company_id;
    this.SaConfigService = SaConfigService;
    this.CompanyService = CompanyService;
    this.DistStockService = DistStockService;
    this.ZipSearchLogic = ZipSearchLogic;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '変更しますか？',
        ok: '変更する',
        cancel: '戻る'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '変更しました',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };

    $scope.$watch('$ctrl.deviceConfig.zip_code', current => {
      if (current && !this.deviceConfig.location) {
        this.ZipSearchLogic.get(current).then(address => {
          $timeout(() => {
            this.deviceConfig.location = address.prefecture_name + address.city_name + address.town_name;
          });
        });
      }
    });
  }

  $onInit() {
    //company_idに不正な値が指定されてないかを確認する
    this.CompanyService.show({id: this.companyId}).$promise
      .catch(err => {
        if (err.status === 404 || err.status === 403) {
          this.$state.go('oem_main.oem_home');
        }
      });

    this.SaConfigService.oem_api.show({id: this.id}, (response) => {
      this.deviceConfig = response;
      this.deviceConfig.current_id = this.deviceConfig.distribution_id;

      let serviceType = this.deviceConfig.lait_service_code.match(/^ts[sw]/)[0];
      this.DistStockService.oem_api.index({service_type: serviceType}, (response) => {
        let stocks = response.dist_stocks;
        stocks.unshift(this.deviceConfig.distribution_id);
        this.distStocks = stocks;
      });
    }, err => {
      if (err.status === 404 || err.status === 403) {
        this.$state.go('oem_main.oem_home');
      }
    });
  }

  showConfirm(deviceConfig, ev) {
    this.$mdDialog.show(this.dialog.confirm.targetEvent(ev))
      .then(() => {
        deviceConfig.base_unit_price = deviceConfig.base_unit_price || 0;
        deviceConfig.power_unit_price = deviceConfig.power_unit_price || 0;
        this.SaConfigService.oem_api.update(
          deviceConfig,
          (okResponse) => { this.$mdDialog.show(this.dialog.success); },
          (errResponse) => { this.$mdDialog.show(this.dialog.error.content(errResponse.data.message)); }
        );
      });
  }
}

export default angular.module('leptonApp.oemDeviceConfigEdit', [uiRouter, SaConfigService, CompanyService, DistStockService, ReadonlyIf, ZipSearchLogic])
  .config(routing)
  .component('oemDeviceConfigEdit', {
    template: require('./device_config_edit.html'),
    controller: OemDeviceConfigEditController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/edit/device_config_edit.component.js